module.exports = __webpack_public_path__ + "img/HMLOGO_WHITE.951825b7.webp";